import {
  SEO_TITLE,
} from '../constants';

function formatSEOTitle(title: string) {
  return `${SEO_TITLE} | ${title}`;
}

export default formatSEOTitle;